import { normilizeShowtimesInputValue, normilizeShowtimesReturnValue } from "./utils";

export const getByIds = async (supabase, ids) => {
  const result = await supabase
  .from('showtimes')
  .select()
  .in('id', [ids])
  // .neq('isBlocked', true);
  result.error && console.error('getByIds method: ', result.error);
  return normilizeShowtimesReturnValue(result?.data);
}

export const getByMovieId = async (supabase, movieId) => {
  const result = await supabase
  .from('showtimes')
  .select()
  .eq('movie_id', movieId)
  .gte('start_at', new Date().toISOString()) // Only get future showtimes
  .order('start_at', { ascending: true });
  result.error && console.error('getByMovieId method: ', result.error);
  return normilizeShowtimesReturnValue(result?.data) || [];
}

export const getAllByMovieId = async (supabase, movieId) => {
  const result = await supabase
  .from('showtimes')
  .select()
  .eq('movie_id', movieId)
  .order('start_at', { ascending: false })
  .limit(200);
  result.error && console.error('getAllByMovieId method: ', result.error);
  return normilizeShowtimesReturnValue(result?.data) || [];
}

export const checkIds = async (supabase, ids) => {
  const result = await supabase
  .from('showtimes')
  .select('id')
  .in('id', ids)
  result.error && console.error('checkIds method: ', result.error);
  return result?.data;
}

export const checkId = async (supabase, id) => {
  const result = await supabase
  .from('showtimes')
  .select('id')
  .eq('id', id)
  result.error && console.error('checkId method: ', result.error);
  return result?.data;
}

export const getAll = async (supabase) => {
  const result = await supabase
  .from('showtimes')
  .select();
  result.error && console.error('getAll method: ', result.error);
  return normilizeShowtimesReturnValue(result?.data);
}

export const put = async (supabase, data) => {
  try {
    for (const element of data) {
    const existing = await checkId(supabase, element.id);
    existing && existing.length > 0 
      ? await updateById(supabase, element.id, element) 
      : await supabase
        .from('showtimes')
        .insert(normilizeShowtimesInputValue(data));
        };
  } catch (error) {
    console.error('put method: ', error);
  }
}

export const updateById = async (supabase, id, data) => {
  const normalized = normilizeShowtimesInputValue([data])[0];
  // Don't overwrite film_format if the incoming data doesn't specify one
  if (!normalized.film_format) {
    delete normalized.film_format;
  }
  const result = await supabase
  .from('showtimes')
  .update(normalized)
  .eq('id', id)
  .select();
  result.error && console.error('updateById method: ', result.error);
  return normilizeShowtimesReturnValue(result?.data);
}

export const updateFilmFormat = async (supabase, id, filmFormat) => {
  const result = await supabase
  .from('showtimes')
  .update({ film_format: filmFormat })
  .eq('id', id)
  .select();
  result.error && console.error('updateFilmFormat method: ', result.error);
  return result?.data;
} 

export const getAllWithinTimeFrame = async (supabase, timeFrom, timeTo) => {
  const result = await supabase
  .from('showtimes')
  .select()
  .gte('start_at', timeFrom)
  .lte('start_at', timeTo)
  .order('start_at', { ascending: true })
  .limit(5000);
  result.error && console.error('getAllWithinTimeFrame method: ', result.error);
  return normilizeShowtimesReturnValue(result?.data);
}

export const getByFormatsWithinTimeFrame = async (supabase, formats, timeFrom, timeTo) => {
  const result = await supabase
  .from('showtimes')
  .select()
  .in('film_format', formats)
  .gte('start_at', timeFrom)
  .lte('start_at', timeTo)
  .order('start_at', { ascending: true })
  .limit(5000);
  result.error && console.error('getByFormatsWithinTimeFrame method: ', result.error);
  return normilizeShowtimesReturnValue(result?.data);
}

export const getAllWithinTimeFrameByTheater = async (supabase, theater, timeFrom, timeTo) => {
  const result = await supabase
  .from('showtimes')
  .select()
  .eq('theaterId', theater)
  .gte('start_at', timeFrom)
  .lte('start_at', timeTo)
  // .neq('isBlocked', true);
  result.error && console.error('getAllWithinTimeFrameByTheater method: ', result.error);
  return normilizeShowtimesReturnValue(result?.data);
}

export const deleteById = async (supabase, id) => {
  const result = await supabase
    .from('showtimes')
    .delete()
    .eq('id', id);
  result.error && console.error('deleteById method: ', result.error);
}

export const deleteAll = async (supabase) => {
  const result = await supabase
    .from('showtimes')
    .delete()
    .neq('id', null)
  result.error && console.error('deleteAll method: ', result.error);
}

